import { useLocale } from "@calcom/lib/hooks/useLocale";
import { useEffect, useState } from "react";

const DEFAULT_COUNTDOWN_SECONDS = 15;
const RING_RADIUS = 36;
const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS;

export const SearchingDatesCountdown = ({ seconds = DEFAULT_COUNTDOWN_SECONDS }: { seconds?: number }) => {
  const { t } = useLocale();
  const [secondsLeft, setSecondsLeft] = useState(seconds);

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const dashoffset = RING_CIRCUMFERENCE * (1 - secondsLeft / seconds);

  return (
    <div
      data-testid="searching-dates-countdown"
      className="col-span-7 row-span-6 flex aspect-[7/6] flex-col items-center justify-center gap-4 text-center">
      <div className="relative h-24 w-24">
        <svg className="h-full w-full -rotate-90" viewBox="0 0 80 80" aria-hidden="true">
          <circle cx="40" cy="40" r={RING_RADIUS} className="stroke-subtle fill-none" strokeWidth="6" />
          <circle
            cx="40"
            cy="40"
            r={RING_RADIUS}
            className="stroke-brand-default fill-none transition-[stroke-dashoffset] duration-1000 ease-linear"
            strokeWidth="6"
            strokeLinecap="round"
            strokeDasharray={RING_CIRCUMFERENCE}
            strokeDashoffset={dashoffset}
          />
        </svg>
        {secondsLeft > 0 && (
          <span className="text-emphasis absolute inset-0 flex items-center justify-center text-2xl font-semibold tabular-nums">
            {secondsLeft}
          </span>
        )}
      </div>
      <p className="text-default max-w-[14rem] text-sm font-medium">
        {secondsLeft > 0 ? t("searching_available_dates") : t("almost_ready")}
      </p>
    </div>
  );
};

export default SearchingDatesCountdown;
